// Mobile Loading Spinner
// Full-screen loading indicator for mobile calculations
// Prevents interaction during processing

import React from 'react';

const MobileLoadingSpinner = ({ message = 'Calculating...', subMessage = '' }) => {
    return (
        <div className="fixed inset-0 bg-white bg-opacity-95 flex items-center justify-center z-[100]"
             style={{
                 paddingTop: 'max(env(safe-area-inset-top), 0px)',
                 paddingBottom: 'max(env(safe-area-inset-bottom), 0px)'
             }}>
            <div className="text-center px-6">
                {/* Spinner */}
                <div className="relative mx-auto mb-6" style={{ width: '64px', height: '64px' }}>
                    <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
                    <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
                </div>
                
                {/* Message */}
                <p className="text-lg font-semibold text-gray-900 mb-2">{message}</p>
                {subMessage && (
                    <p className="text-sm text-gray-600">{subMessage}</p>
                )}
                
                {/* Progress Dots */}
                <div className="flex justify-center gap-2 mt-4">
                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
                </div>
            </div>
        </div>
    );
};

export default MobileLoadingSpinner;

